export const MATERIAL_CONSULTATION_EMAIL_SUBJECT = "Consultation formats de matière";

export const MATERIAL_CONSULTATION_EMAIL_BODY = `Bonjour [Nom du contact fournisseur],

Dans le cadre de notre activité, nous souhaitons obtenir une consultation pour l'approvisionnement en matière selon les besoins détaillés dans le fichier joint.

Vous trouverez en pièce jointe le détail de notre demande (nuances, dimensions, quantités).

Merci de bien vouloir nous transmettre votre meilleure offre en précisant :
- Le prix unitaire et/ou total
- Le délai de livraison
- Les conditions de livraison (Incoterm, franco de port, etc.)
- La validité de votre offre

N'hésitez pas à revenir vers nous pour toute précision complémentaire.

Dans l'attente de votre retour,

Cordialement,
[Nom]
[Fonction]
[Société]
[Téléphone]`;
